export class CarouselUtils {
    static isMobile() {
        return window.matchMedia("(max-width: 767px)").matches;
    }
    static isLargeScreen() {
        return window.matchMedia("(min-width: 1200px)").matches;
    }
    static useNavs(swiperSectionEl, enable = true) {
        //enables pagination and nav
        const hiddenClass = 'is-hidden';
        const prevEl = swiperSectionEl.querySelector('[data-role="swiper-button-prev"]');
        const nextEl = swiperSectionEl.querySelector('[data-role="swiper-button-next"]');
        if (prevEl && nextEl) {
            prevEl.classList.toggle(hiddenClass,!enable);
            nextEl.classList.toggle(hiddenClass,!enable);
            return {
                hiddenClass,
                nextEl,
                prevEl,
                // the buttons draw their own chevron, so skip Swiper's injected SVG arrow
                addIcons: false
            };
        }
    }
    static usePagination(swiperSectionEl, enable = true) {
        const hiddenClass = 'is-hidden';
        const el = swiperSectionEl.querySelector('[data-role="swiper-pagination"]');
        if (el) {
            el.classList.toggle(hiddenClass, !enable);
            return {
                el,
                hiddenClass,
                clickable: true
            };
        }
    }
    static getSlidesOffset(sectionEl) {
        const defaultPadding = 16;
        let slidesOffsetPx = getComputedStyle(sectionEl).getPropertyValue('--section-padding');
        const result = parseInt(slidesOffsetPx.replace(/px/ig,''),10);
        return isNaN(result) ? defaultPadding : result;
    }
    static getValueInRange(value, min, max) {
        if (value < min) {
            return min;
        } else if (value > max) {
            return max;
        } else {
            return value;
        }
    }
}